import React, {Component, Fragment} from 'react';
import {compose, withProps, withHandlers} from 'recompose';
import {withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow} from 'react-google-maps';
import googleMapsStyles from '../../Schools/assets/js/googleMapsStyles';
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import logo from '../../Layout/assets/img/logo-agep-simple.svg';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

const Map = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=" + GOOGLE_MAPS_API_KEY,
        loadingElement: <div style={{height: `100%`}}/>,
        containerElement: <div style={{height: `100%`}}/>,
        mapElement: <div style={{height: `100%`}}/>,
    }),
    withHandlers(() => {
        const refs = {
            map: undefined,
        };

        return {
            onMapMounted: () => ref => {
                if (ref) {
                    refs.map = ref;
                    refs.map.panBy(0, -60);
                }
            },
        }
    }),
    withScriptjs,
    withGoogleMap
)((props) => {
    const latitude = 46.2061082;
    const longitude = 6.1380607;

    return (
        <GoogleMap
            ref={props.onMapMounted}
            defaultZoom={16}
            center={{
                lat: latitude,
                lng: longitude,
            }}
            defaultOptions={{
                disableDefaultUI: true,
                fullscreenControl: true,
                zoomControl: true,
                styles: googleMapsStyles,
            }}
        >
            <InfoBox
                defaultPosition={new window.google.maps.LatLng(latitude, longitude)}
                options={{
                    alignBottom: true,
                    pane: 'mapPane',
                    pixelOffset: new window.google.maps.Size(-90, 0),
                    boxStyle: {
                        width: '180px',
                        height: 'auto',
                    },
                    closeBoxURL: ``,
                    enableEventPropagation: true
                }}
            >
                <div className="info-box-logo">
                    <div className="box">
                        <img src={logo} alt="" width={83} height={18} />
                        <div className="address">
                            Rue Saint-Jean 98<br />
                            Case postale<br />
                            1211 Genève 3
                        </div>
                        <div className="arrow"></div>
                    </div>
                </div>
            </InfoBox>
        </GoogleMap>
    );
});

class ContactMap extends Component {
    render() {
        return (
            <div className="map-wrapper">
                <Map />
            </div>
        );
    }
}

export default ContactMap;



// WEBPACK FOOTER //
// ./src/features/Contact/components/ContactMap.js